module.exports = __webpack_public_path__ + "img/logo.82b52221.jpg";